import React, { useEffect } from "react";
import DataTable from "../../datatable";
import { useState } from "react";
import { PAGINATION_DEFAULT } from "../../../utils/constants";
import { useHistory } from "react-router-dom";
import {
  useDeleteRecruitmentEmailTemplates,
  useGetRecruitmentEmailTemplates,
} from "../../../redux/email-templates/hook/recruitment";
import AddRecruitmentEmailTemplate from "../../modal/hr-section/recruitment/add-recruitment-email-template";
import Button from "../../button";

const RecruitmentEmailTemplatesTab = () => {
  useEffect(() => {}, []);

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: "",
  });

  const { data: recruitment_email_templates } = useGetRecruitmentEmailTemplates(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  );
  const [tableType, setTableType] = useState("email");

  const switchFunction = () => {
    if (tableType === "email") {
      setTableType("table");
    } else {
      setTableType("email");
    }
  };

  const [showAddTemplate, setShowAddTemplate] = useState(false);

  const [title, setTitle] = useState("Add Email Template");
  const [buttonText, setButtonText] = useState(null);

  const { mutateAsync: deleteTemplate } = useDeleteRecruitmentEmailTemplates();

  const [recruitmentEmailData, setRecruitmentEmailData] = useState(null);

  const history = useHistory();

  const tableConfig = {
    headers: ["Template Name", "Subject", "Salutation", "Name Type"],
    keys: ["template_name", "subject", "salutation", "name_type"],
    mobileHeader: {
      left: {
        title: "Template Name",
        key: "template_name",
      },
      right: {
        title: "Subject",
        key: "subject",
      },
    },
  };

  const actionConfig = [
    {
      name: "View/Update",
      color: "green",
      action: (id) => {
        let index = recruitment_email_templates.data.findIndex(
          (item) => item.id === id
        );
        setTitle("Update Email Template");
        setButtonText("Update Template");
        setRecruitmentEmailData(recruitment_email_templates.data[index]);
        setShowAddTemplate(true);
      },
    },
    {
      name: "Remove",
      color: "red",
      action: (id) => {
        let index = recruitment_email_templates.data.findIndex(
          (item) => item.id === id
        );
        deleteTemplate(recruitment_email_templates.data[index].id);
      },
    },
  ];

  return (
    <div className="flex flex-col bg-white rounded">
      {showAddTemplate ? (
        <AddRecruitmentEmailTemplate
          isOpen={showAddTemplate}
          closeModal={() => setShowAddTemplate(false)}
          templateData={recruitmentEmailData}
          title={title}
          buttonText={buttonText}
        />
      ) : null}
      <div className="flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3">
        <div className="md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full">
          Recuitment Email Templates
        </div>
        <div className="flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[60%] w-full">
          <div className="md:w-fit w-[100%]">
            <Button
              text="New Email Template"
              type="submit"
              theme="primary"
              className="flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center"
              textClass={"!text-[11px]"}
              leftIcon={"add"}
              onClick={() => {
                setRecruitmentEmailData(null);
                setTitle("Add Email Template");
                setButtonText("Add Template");
                setShowAddTemplate(true);
              }}
            />
          </div>
        </div>
      </div>
      <hr className="divider mt-2 mb-1" />
      <DataTable
        data={recruitment_email_templates}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        tableType={tableType}
        switchFunction={switchFunction}
        layoutSwitch={true}
        searchData={true}
        noCheck={true}
      />
    </div>
  );
};

export default RecruitmentEmailTemplatesTab;
